import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http
    .postData("/code-blue-activation", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/code-blue-activation/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/code-blue-activation`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/code-blue-activation/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDokter(id: number, data) {
  const response = await http
    .putData(`/code-blue-activation/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPerawat(id: number, data) {
  const response = await http
    .putData(`/code-blue-activation/${id}/sign-perawat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/code-blue-activation/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return isEmpty(response?.data) ? null : response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/code-blue-activation/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDokter,
  signPerawat,
  destroy,
  print
};
